module.exports = __webpack_public_path__ + "img/92d7e9c.png";